import { useContext } from "react";
import { AppContext } from "../App";
import { formatDate, formatMoney } from "../Helpers";
import { MdArrowOutward } from "react-icons/md";

export default function One({ data }) {
  const appContext = useContext(AppContext);

  function view() {
    appContext.navTo({
      item: "side-view",
      subItem: "payment-options",
      extraItem: data.uuid,
    });
  }

  return (
    <div className="entity-card p-3 mb-2 border rounded bg-white shadow-sm d-flex align-items-center" onClick={view} style={{ cursor: "pointer" }}>
      <div className="entity-card-main w-100">
        
        {/* Title row: Stacks on mobile, splits side-by-side on desktop */}
        <div className="entity-card-title-row d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2 mb-2">
          <h6 className="entity-card-title mb-0 text-truncate font-bold" style={{ maxWidth: "250px" }}>
            {data.fullname || "Customer"}
          </h6>
          <span className="status-pill status-pill-success px-2 py-0.5 small fw-semibold text-nowrap">
            Paid {formatMoney(data.amount || 0)}
          </span>
        </div>

        {/* Metadata section: Clean grid distribution that scales flawlessly */}
        <div className="entity-card-meta-grid row g-1 text-muted small">
          <div className="col-auto pe-3">
            <span className="text-dark fw-medium">{data.model || "Motorcycle not set"}</span>
          </div>
          <div className="col-auto border-start ps-3 text-muted">
            <span>Recorded {formatDate(data.dateCreated)}</span>
          </div>
        </div>
        
      </div>

      {/* Persistent End Action Target Key - hidden on tiny screens to optimize viewing canvas */}
      <div className="entity-card-end d-flex align-items-center justify-content-center ps-2 text-muted ms-auto d-none d-sm-flex">
        <MdArrowOutward size={18} />
      </div>
    </div>
  );
}